import { styled } from '@mui/system'
import { colors, fontSizes } from '../consts'

export const LinkImageList = styled('ul')(
  ({ theme }) => ({
    fontSize: fontSizes.small,
    margin: 0,
    padding: 0,
    '& li': {
      listStyle: 'none',
      marginBottom: theme.spacing(2),
      '& img': {
        marginRight: theme.spacing(2),
        width: 32,
        height: 32,
        fill: colors.yellow,
        borderRadius: 4,
      },
      '& a': {
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'center',
        textDecoration: 'none',
        color: colors.text,
      },
    },
  })
)